import { getDispatcher } from '@sie-private/telemetry-js';
import { withAdobeEcid } from '@sie-private/telemetry-js-helpers';
import createTelemetryJsConfig from './createTelemetryConfig';
import getUserTelemetryPayload from './getUserTelemetryPayload';

const PRIVACY_ALLOWED_VALUES = ['exempt', 'minimal', 'all'];

const initTelemetryData = ({
  telemetry,
  webToolbarType,
}) => createTelemetryJsConfig({ webToolbarType })
  .then(async (config) => {
    const privacyPolicy = config?.platformPrivacyWs1;
    if (
      telemetry.privacyPolicy !== privacyPolicy
        && PRIVACY_ALLOWED_VALUES.includes(privacyPolicy)) {
      const adobeConfigs = {
        adobeOrgId: 'BD260C0F53C9733E0A490D45@AdobeOrg',
        adobeDataStreamId: '1fe82fa9-60d9-426a-971b-557bad4bb083',
      };
      const dispatch = await withAdobeEcid(getDispatcher(config), adobeConfigs);

      const reporter = {
        dispatch: ({ payload }) => dispatch({
          ...config,
          ...getUserTelemetryPayload(),
          ...payload,
        }),
      };
      telemetry.setReporter(reporter);
    }
  });

export default initTelemetryData;
